import { useEffect } from 'react';
import { useModal } from '@pcmp/react-providers';
import { useNavigate } from 'react-router-dom';

import { AboutSider } from '@/components/siders/about';

function AboutPage() {
  const navigate = useNavigate();
  const { openModal } = useModal();

  useEffect(() => {
    navigate('/');

    openModal({
      component: AboutSider,
      props: {},
    });
  }, [navigate, openModal]);

  return null;
}
export default AboutPage;
